export const pathHomePage = "/";
export const pathLogin = "/login";
export const pathRegister = "/register";
export const pathTherapistHome = "/patients";
export const pathPatientHome = "/patient";
export const pathPatientActivityPlan = "/patient/activity-plan";
export const pathTherapistActivityPlan = "/patients/:id/activity-plan";
export const therapistActivityPlanUrl = (id) => `/patients/${id}/activity-plan`;
export const pathPatientProfile = "/patients/:id/profile";
export const patientProfileUrl = (id) => `/patients/${id}/profile`;
export const pathVideoCall = "/video-call";
export const pathAccount = "/account";
export const pathCaregiverSupport = "/patients/:id/caregiver-support";
export const caregiverSupportUrl = (id) => `/patients/${id}/caregiver-support`;
export const pathPatientCaregiverSupport = "/patient/caregiver-support";

export const primaryColor = "#26A9B6";

const isRemote = true;

export const API_URL = isRemote
  ? "https://vippstar.eodyne.com/video-call-server/api"
  : "http://localhost:5000/api";

export const SOCKET_URL = isRemote
  ? "https://vippstar.eodyne.com"
  : "http://localhost:5000";
